import { name } from "./users.reducers";

export const selectSlice = (state) => state[name];

export const selectUsers = (state) => selectSlice(state).users;

export const selectUserRoles = (state) => selectSlice(state).userRoles;

export const selectSelectedUser = (state) => selectSlice(state).selectedUser;

export const selectSelectedUserRole = (state) =>
  selectSlice(state).selectedUserRole;

export const selectTotalUsers = (state) => selectSlice(state).totalUsers;

export const selectUsersFilters = (state) => selectSlice(state).usersFilter;

export const selectInvitationsFilters = (state) => selectSlice(state).invitationFilters;

export const selectSubscription = (state) => selectSlice(state).userSubscription;

export const selectAllInvitations = (state) => selectSlice(state).invitations;

export const selectExistingInvitaion = (state) => selectSlice(state).userInvited;
